/* eslint-disable react/display-name */
import React from 'react';
import { Spinner, SpinnerSize, Stack, StackItem } from '@fluentui/react';
import ElevatedCard from '../../components/ui/ElevatedCard';

export default function () {
  return (
    <div className="master-loading">
      <ElevatedCard>
        <Stack>
          <StackItem>
            <div className="master-loading__spinner">
              <Spinner size={SpinnerSize.large} label="Loading..." />
            </div>
          </StackItem>
        </Stack>
      </ElevatedCard>
    </div>
  );
}
